import React from 'react';
import { useTranslation } from 'react-i18next';
import Form from '../../misc/form/form';
import { generate_use_form_schema } from '../../../../steps/formStep';
import useForm from '../../../../utils/useForm';
import Button from '../../ui/button/button';
import Message from '../../misc/message/message';
import { ErrorMessage } from '../../misc/message/message';

export default function TransferFormStep({ config, onSubmit = () => {}, isSubmitting = false, isGoingBack = false, step = {} }) {
    const { t } = useTranslation();
    const generic_form  = config.generic_form;
    const title = generic_form.header.title;
    const messageType = generic_form.message.type;
    const messageTitle = generic_form.message.title;
    const messageDescription = generic_form.message.description;

    const { errors: formErrorsTransferBackend } = generic_form.form;

    const [displayErrorsFrontendMessage, setDisplayErrorsFrontendMessage] = React.useState(false);
    
    let transferSchema = React.useRef(generate_use_form_schema(generic_form.form.fields));

    const [_form, setFormValue, setFormObject, , formErrors, onValidate, onChangeErrors] = useForm(transferSchema.current, {
        validateOnChange: false,
        clearOnChange: true,
    });

    const isFormInvalid = React.useMemo(() => {
        return Object.keys(formErrors).length > 0;
    }, [formErrors]);

    const _onSubmit = React.useCallback(() => {
        if (isFormInvalid) {
            return;
        }
        let { valid } = onValidate()

        if (!valid) {
            setDisplayErrorsFrontendMessage(true);
            return;
        }
        setDisplayErrorsFrontendMessage(false);
        onSubmit({
            data: {
                ticket_transfer: _form,
            }
        });
    },[onSubmit, isFormInvalid, _form]);

    React.useEffect(() => {
        if (Object.keys(formErrorsTransferBackend).length) {
            onChangeErrors({...formErrorsTransferBackend});
        }
    },[formErrorsTransferBackend]);

    return (
        <>
            {displayErrorsFrontendMessage && <ErrorMessage config={{
                error_messages: {
                    title: t('widget.front_error_message.title'),
                    body: t('widget.front_error_message.description')
                }
            }}/>}
            <div>
                <h3 className='neo-form-step-title'>{title}</h3>
                <Message type={messageType} title={messageTitle} description={messageDescription}/>
                <Form form={_form} setFormValue={setFormValue} setFormObject={setFormObject} fields={generic_form.form.fields} formIndex='transfer' formErrors={formErrors}/>
                <div className='neo-cta-container'>
                    <Button type='primary' className='neo-cta-next' isLoading={isSubmitting} onClick={_onSubmit} label={t('widget.resale.tickets.cta-next')} disabled={isFormInvalid}/>
                </div>
            </div>
        </>
    )
}
